;(function () {
  angular.module('contrast.date').directive('calendarDay', function () {
    return {
      restrict: 'A',
      scope: {
        calendarDay: '='
      },
      templateUrl: 'views/common/calendar_day.html'
    }
  })
})()
